import { OrderedMap } from 'immutable';

export const FILTER_KEYS = Object.freeze({
  OWNERS: 'owners',
  BUILDS: 'builds',
  OSES: 'oses',
  BROWSERS: 'browsers',
  TAGS: 'tags',
  FRAMEWORKS: 'frameworks',
});

export const FILTERS_INFO = Object.freeze({
  [FILTER_KEYS.OWNERS]: Object.freeze({
    name: 'Owner',
    search: true,
  }),
  [FILTER_KEYS.BUILDS]: Object.freeze({
    name: 'Build',
    search: true,
  }),
  [FILTER_KEYS.OSES]: Object.freeze({
    name: 'OS',
  }),
  [FILTER_KEYS.BROWSERS]: Object.freeze({
    name: 'Browser',
  }),
  [FILTER_KEYS.TAGS]: Object.freeze({
    name: 'Tag',
    search: true,
  }),
  [FILTER_KEYS.FRAMEWORKS]: Object.freeze({
    name: 'Framework',
  }),
});

export const FILTERS_MAP = OrderedMap(FILTERS_INFO);

export const FILTER_TYPES = Array.from(FILTERS_MAP.keys()).concat([
  'dateFilter', 'query',
]);

export const CONCURRENCY_FILTERS_MAP = OrderedMap({
  [FILTER_KEYS.OWNERS]: FILTERS_INFO[FILTER_KEYS.OWNERS],
});
